module.exports = __webpack_public_path__ + "img/sequence-kyoto-gojo.0a1729bb.jpg";